import { audienceAssociationSectionStyle } from './audience-association-section-style';
import { convertToLocalStyle } from './utils/convert-style';
import { commonDoubleListBoxStyle } from './double-list-box-style';
import { glyphIconStyle } from './glyph-icon-style';
import { helpbuttonStyle, searchboxStyle } from './shared-styles-from-theme-fluent';

export const audienceBulkAssociationStyle = ({ palette }) => ({
  ...audienceAssociationSectionStyle({ palette }),
  '& .association__body, .exclusion__body': {
    ...searchboxStyle({ palette }),
    ...convertToLocalStyle(glyphIconStyle({ palette })),
    ...convertToLocalStyle(helpbuttonStyle({ palette })),
    ...commonDoubleListBoxStyle({ palette }),

    '& .DMP_doublelistbox_section .doubleListBox.layout-columns .layout-columns-container .layout-columns-element': {
      '& .dlb-source-container .dlb-source.dlb-source-list, .dlb-selected-container .dlb-selected.dlb-selected-list': {
        '& .dlbItem .dlbItem-content .audience-association-selector-item-table .audience-association-selector-item-col.audience-association-selector-item-name-col': {
          width: 'calc(100% / 3)',
        },
      },
    },

    '& .row': {
      marginLeft: 0,
      marginRight: 0,
    },
  },
});
